import { useMember } from "@/hooks/use-member";
import type { PlainPrompt } from "@/queries/prompt-queries";
import { useAuthenticatedUser } from "@/queries/user-queries";
import { useMemo, type FC } from "react";

export const CommandCreatedBy: FC<{
    command: PlainPrompt;
}> = ({ command }) => {
    const { data: user } = useAuthenticatedUser();
    const { member: currentMember } = useMember(user?.id);
    const { member: creatorMember } = useMember(command.metadata?.creator?.id);

    const label = useMemo(() => {
        return currentMember?.userId === creatorMember?.userId ? "You" : creatorMember?.fullName || "Unknown";
    }, [creatorMember, currentMember]);

    if (!currentMember || !creatorMember) {
        return <div className="text-xs text-content-secondary">By Unknown</div>;
    }

    return (
        <div data-testid="creator" className="text-xs text-content-secondary">
            By {label}
        </div>
    );
};
